export enum SpinnerSize {
    XSmall = 'x-small',
    Small = 'small',
    Big = 'big',
}
